module.exports = __webpack_public_path__ + "img/完成工单.e6602334.png";